import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "./Header";

const NotFoundPage = () => {
  const user = useSelector((store) => store.user.data);
  const homePath = user ? "/browse" : "/";

  return (
    <>
      <Header />
      <main className="min-h-screen bg-black text-white flex items-center justify-center px-6">
        <div className="text-center max-w-xl">
          <h1 className="text-6xl font-bold text-red-600">404</h1>
          <h2 className="mt-4 text-2xl font-semibold">Page not found</h2>
          <p className="mt-3 text-gray-400">
            The page you are looking for does not exist or may have been moved.
          </p>
          <Link
            to={homePath}
            className="inline-block mt-8 bg-red-600 hover:bg-red-700 px-5 py-2.5 rounded-md font-medium transition-colors"
          >
            Go to Home
          </Link>
        </div>
      </main>
    </>
  );
};

export default NotFoundPage;
